/**
 * Note: This Component is used to handle only installs from the Shopify domain
 */

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Axios from "axios";

import {
  LOGIN_WITH_SHOPIFY,
  GENERIC_APP_CONNECT,
  DOMAIN_NAME,
} from "../_actions/endpoints";
import Format from "string-format";
import TldrBase from "../TldrLogin/TldrBase";
import { ACCESS_DENIED, PUBLISHING, ROOT } from "../_utils/routes";
import { processLogin } from "../_actions/authActions";
import { FaArrowLeft } from "react-icons/fa";
import { Box, Button, Icon } from "@chakra-ui/react";
import { AppIdType } from "../_utils/constants";
import axios from "axios";
import { useTranslation } from "react-i18next";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Callback(props) {
  const { t } = useTranslation(["common"]);
  let query = useQuery();
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("Connecting..");
  const [message, setMessage] = useState("Please wait, connecting..");

  const isAuthenticated = props?.auth?.isAuthenticated;

  useEffect(() => {
    const shop = query.get("shop");
    const state = query.get("state");
    const code = query.get("code");

    // If there is no shop then show access denied
    if (!shop) {
      props.history.push(ACCESS_DENIED);
      return;
    }

    const nonce = localStorage.getItem("nonce");
    if (state !== nonce) {
      setLoading(false);
      setTitle("Error.");
      setMessage(t("errors.login_blocked"));
      return;
    }
    ///Check whether used logged in or not
    if (!isAuthenticated) {
      setMessage(t("login_with_shopify"));
      const url = Format(LOGIN_WITH_SHOPIFY, query.get("shop"));
      axios.post(url, {
        code: code,
      }).then((res) => {
        props.processLogin(res.data, props, PUBLISHING);

        setLoading(false);
        setTitle("Success.");
        setMessage(t("login_success_with_shopify"));
      }).catch(e => {
        setLoading(false);
        setTitle("Failed");
        setMessage(t("errors.login_failed"));
      })
    } else {
      setMessage(t("connecting_to_shopify"));
      let url = Format(GENERIC_APP_CONNECT + "?shop={}", query.get("shop"));
      try {
        const res = Axios.post(url, {
          code: code,
          app_id: AppIdType.SHOPIFY_APP,
          callback_url: DOMAIN_NAME,
        });
        setLoading(false);
        setTitle("Success.");
        setMessage(t("connected_successfully"));
        props.history.push(PUBLISHING);
      } catch (e) {
        setLoading(false);
        setTitle("Failed");
        setMessage(t("errors.contact_online_support"));
      }
    }

  }, []);

  return (
    <TldrBase>
      <Box textAlign="center">{title}</Box>
      {loading && (
        <Box className="secondary-links" textAlign="center" m={2}>
          <Button type="submit" variant="outline" isLoading></Button>
        </Box>
      )}
      <Box textAlign="center">{message}</Box>
      <Box className="secondary-links" textAlign="center" mt={2}>
        <Link to={ROOT}>
          <Icon as={FaArrowLeft} mr={1} />
          {t("back_to_login")}
        </Link>
      </Box>
    </TldrBase>
  );
}

Callback.propTypes = {};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    processLogin: (data, props, redirectTo) =>
      dispatch(processLogin(data, props, redirectTo)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Callback);
